import React from 'react';
import { Shield as ShieldIcon } from 'lucide-react';
const Guarantee = () => {
  return <section className="py-16 bg-amber-50" data-id="element-144">
      <div className="container mx-auto px-4" data-id="element-145">
        <div className="max-w-3xl mx-auto text-center" data-id="element-146">
          <div className="mb-6 flex justify-center" data-id="element-147">
            <div className="bg-custom-brown p-4 rounded-full" data-id="element-148">
              <ShieldIcon size={40} className="text-white" data-id="element-149" />
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800" data-id="element-150">
            Garantía de satisfacción 100%
          </h2>
          <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-151">
            <p className="text-lg text-gray-700 mb-4" data-id="element-152">
              Si en 7 días no te ayuda, te devolvemos tu dinero sin preguntas.
              Estamos tan seguros de que te encantará este método que te
              ofrecemos una garantía completa.
            </p>
            <p className="text-lg text-gray-700" data-id="element-153">
              Prueba las recetas, implementa el sistema, y si no ves una
              diferencia real en tu rutina de cocina, simplemente escríbenos y
              te devolveremos cada centavo.
            </p>
          </div>
          <div className="inline-block bg-custom-brown bg-opacity-20 px-4 py-2 rounded-full" data-id="element-154">
            <p className="font-bold text-custom-brown" data-id="element-155">
              Sin riesgos • 7 días de garantía • Devolución 100%
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Guarantee;